import React, { useState } from "react";
import { buildFlowTree } from "../../utils/buildFlowTree";
import TopGuidedNavigation1 from "./skins/TopGuidedNavigation1";
import TopGuidedNavigation2 from "./skins/TopGuidedNavigation2";
import SideNavigationGuided1 from "./skins/SideNavigationGuided1";
import SideNavigationFree1 from "./skins/SideNavigationFree1";
import TopFreeNavigation1 from "./skins/TopFreeNavigation1";
import TopFreeNavigation2 from "./skins/TopFreeNavigation2";
import SideMenuSkin1 from "./skins/SideMenuSkin1";
import TopMenuSkin1 from "./skins/TopMenuSkin1";
import { useEvents } from "../../hooks/useEvents";

interface FlowNavigationWrapperProps {
  criteriaData: any;
}

const navigationSkins: Record<string, React.ComponentType<any>> = {
  navigationtpguided1: TopGuidedNavigation1,
  navigationtpguided2: TopGuidedNavigation2,
  navigationsideguided1: SideNavigationGuided1,
  navigationsidefree1: SideNavigationFree1,
  navigationtopfree1: TopFreeNavigation1,
  navigationtopfree2: TopFreeNavigation2,
};

const FlowNavigationWrapper: React.FC<
  FlowNavigationWrapperProps
> = ({ criteriaData }) => {

  const viewConfig = criteriaData?.view_config?.show || {};
  const tree = buildFlowTree(criteriaData?.form_config || []);
  const [activeItem, setActiveItem] = useState<any>(null);
  const showMenu = viewConfig?.headermenu;
  const menuType = viewConfig?.meny_type;
  const externalLinks = viewConfig?.menuitems?.external_links || [];
  const showNavigation = viewConfig?.navigation;
  const navigationType = viewConfig?.navigationType;
  const CurrentNavigation =
    navigationSkins[navigationType] || TopFreeNavigation1;

  const { emit } = useEvents();

  const handleItemClick = (item: any) => {
    setActiveItem(item);
    if (item.url) {
      emit('NAVIGATE_TO_IFRAME', { url: item.url });
    }
  };

  return (
    <div className="flow-layout">
      {showMenu && menuType === "Top" && (
        <TopMenuSkin1 externalLinks={externalLinks} />
      )}

      {showMenu && menuType === "Side" && (
        <SideMenuSkin1 externalLinks={externalLinks} />
      )}

      {showNavigation && (
        <>
          <CurrentNavigation
            tree={tree}
            activeItem={activeItem}
            onItemClick={handleItemClick}
            progressbar={viewConfig?.progressbar}
            progressbarType={viewConfig?.progressbar_type}
            freenavigation={viewConfig?.freenavigation}
          />
        </>
      )}
    </div>
  );
};

export default FlowNavigationWrapper;